import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { getTimeDetails } from '@app-helpers/functions';
import * as d3 from 'd3';
import { line } from 'd3';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
    selector: 'app-barline',
    templateUrl: './barline.component.html',
    styleUrls: ['./barline.component.css']
})
export class BarlineComponent implements OnInit {
    chart: any;
    dynamicNumber = Math.floor((Math.random() * 89999))
    dynamicid ='barlinec' + this.dynamicNumber
    dynamicCntainer = 'container'+this.dynamicNumber
    constructor(public spinner :NgxSpinnerService,private storage: LocalStorageService,public router:Router,private mrkchage:ChangeDetectorRef) { }
@Input('data') public alphabet:any=[];
@Input('totalData') public totalData:any;
@Input('chartOptions') public chartOptions:any;
@Input('type') public type;
@Input('viewSolutionAvailableTimebound') public viewSolutionAvailableTimebound:any = false
@Input('testReport') public testReport;
public num_of_questions = 0
getTimeDetails = getTimeDetails
    ngAfterViewInit() {
        this.spinner.show()
        this.fixbarchart()
        this.spinner.hide()
      document.getElementById(this.dynamicCntainer).addEventListener('scroll',(e:any)=>{
        d3.select('#avgtextvalueid'+this.dynamicCntainer).attr('x',e?.srcElement?.scrollLeft)
        d3.select('#avgtextid'+this.dynamicCntainer).attr('x',e?.srcElement?.scrollLeft)        
      })
      document.getElementById(this.dynamicCntainer).addEventListener('drag',(e:any)=>{
        d3.select('#avgtextvalueid'+this.dynamicCntainer).attr('x',e?.srcElement?.scrollLeft)
        d3.select('#avgtextid'+this.dynamicCntainer).attr('x',e?.srcElement?.scrollLeft)        
      })
    }
    ngOnInit(): void {
    }

  fixbarchart() {
    // container size
    var margin = {
      top: 10,
      right: 10,
      bottom: 20,
      left: 30
    },
      width = document.getElementById(this.dynamicCntainer).offsetWidth,
      height = (document.getElementById(this.dynamicCntainer).offsetHeight ) || 80;
      height = height -20
    var name = 'dashboard';
    this.alphabet = this.alphabet.filter(v=>Number(v?.frequency))
    const num_of_questions= this.alphabet?.filter(v=>v.letter)?.length;
    var tooltip = d3.select(`#${this.dynamicid}`)
    this.num_of_questions =this.alphabet?.filter(v=>v.letter)?.length;//num_of_questions;
    if(this.alphabet?.length == 1){
      this.alphabet.push({letter:'',frequency:0})
    }
    this.mrkchage.detectChanges()
    var xScaleRange = this.alphabet?.length * 100;
    // x scale
    var xScale = d3.scaleBand()
      .rangeRound([0, xScaleRange - 100]).paddingInner(0.5)
    // set x and y scales
    xScale.domain(this.alphabet?.map(function (d) {
      if(d?.letter?.toString()?.length ==1){
        d.letter = '0'+d?.letter
      }
      return d?.letter;
    })||0);

    // x axis
    var xAxis = d3.axisBottom(xScale)
      .scale(xScale)

    var yScale = d3.scaleLinear()
      .domain([0, Math.max(...this.alphabet?.map(d => d?.frequency))])
      .range([height, 0]);

    // create svg container
    let id = `#${this.dynamicid}`;
    var svg = d3.select(id)
      .append('svg')
      .style("overflow-x", "scroll")
      .style("display", "inline-block")
      .attr('class', 'd3-setup-barchart')
      .attr('width', this.alphabet?.length == 2 ? '95%':xScaleRange)
      .attr('height', height + margin.top + margin.bottom)
      if(this.alphabet?.length){
      this.generateAvgLine(svg,yScale,xScale,height,width,margin,(xScaleRange))

      var bargroup  = svg.append('g')

    // create bars
    var bars = bargroup.selectAll('.bar')
      .data(this.alphabet)
      .enter()
      .append('g');

    bars.append('rect')
      .attr('class', function (d, i) {
        return 'bar';
      })
      .attr('x', function (d: any) {
        return xScale(d?.letter) + (xScale.bandwidth() +(margin.left+120)) / 2
      })
      .attr('width',   ()=> {
        return( Math.min(xScale.bandwidth(), 250));
      })
      .attr('y', function (d: any) {
        return yScale(d?.frequency);
      })
      .attr('height', function (d: any) {
        return height - yScale(d?.frequency);
      })
      .attr('fill', this.chartOptions?.color)
      .attr('rx', 7)
      .on('click',  (e, q:any) => {
        let subjecIndex = this.testReport?.testSubjects?.findIndex(v=>v.subjectName == q?.subjectname)
        this.storage.clear('defaulttopicIndex');
        this.storage.clear('questioncounter');
        this.storage.store('defaulttopicIndex',(subjecIndex !=-1 ? subjecIndex :0))
        this.storage.store('questioncounter',(q?.letter-1 > -1 ?q?.letter-1:0))
        if(this.viewSolutionAvailableTimebound){
          if(this.MobileScreen()){
            this.toolTipshow(e,q)
          }else{
            this.router.navigateByUrl('/dashboard/viewsolutionspage')
          }
        }
      })
      .on('mouseover',  (d, i:any) => {
       this.toolTipshow(d,i)
      
      })
      .on('mouseout',  (d, i) => {
      d3.select( '#barlinetooltip').remove()
         
      })
      // bargroup.attr('transform', 'translate(' + (Math.min(xScale.bandwidth(), 250)) / 2  + ',' + 0 + ')')

    // draw x axis
    var xaxis = svg.append('g')
      .attr('id', name + '-x-axis')
      .attr('class', 'x axis')
      .attr('transform', 'translate(' + ((margin.left+120)+Math.min(xScale.bandwidth(), 250)) / 2 + ',' + height + ')')
      .call(xAxis)

    xaxis.selectAll('path')
      .attr('d', '0')
    xaxis.selectAll('line')
      .attr('stroke', 'none')

    svg
      .select('.horizontal')
      .selectAll('.tick')
      .filter(function (d: any) {
        return d === 0 || d % 1 !== 0;
      }).remove();

    }
  }
  generateAvgLine(svg,yScale,xScale,height,width,margin,avgLinex2){
    let avgType= {
      'Unattempted':(this.totalData?.UnAttemptedQuesTimeSpent/this.totalData?.totalUnattempted)||0,
      'Incorrect':(this.totalData?.InCorrectQuesTimeSpent/this.totalData?.incorrectQuetions)||0,
      'Correct':(this.totalData?.CorrectQuesTimeSpent/this.totalData?.correctQuetions)||0
    }
    var avgLine =  avgType[this.type]//Math.floor(this.alphabet?.reduce((a,v)=>a+(+v?.frequency),0)/this.alphabet?.length)||0
    var avgLineYscale = yScale(avgLine)
     // if(avgLine){
    const tranlate =avgLine? `${margin.left*2},0`: (((margin.left+120)+Math.min(xScale.bandwidth(), 250)) / 2 + ',' + 0) 
       let seconds_format =  moment.utc(avgLine*1000).format('mm:ss[s]') 
        svg.append('g').append('line')
        .attr('fill','red')
        .style("stroke", "#A5AAAF")
        .style("stroke-dasharray", ("6, 6"))
        .attr("x1", xScale(0))
        .attr("x2", this.alphabet?.length == 2 ? '95%': avgLinex2  )
        .attr("y1",  avgLine > 0 ? (avgLineYscale > 0?avgLineYscale:0) : height)
        .attr("y2",  avgLine > 0 ? (avgLineYscale > 0?avgLineYscale:0) : height)
        .attr("transform", `translate(${tranlate})`)
        var text = svg.append("g")
            .append("text")
            .attr("x", xScale(0))
          .attr("y", ((avgLineYscale < 0 || avgLineYscale == 0) ? 30 : avgLineYscale ))
            .style("fill", "#A0A3BD")
            .text('Avg. Time')
            .attr("transform", `translate(${5},0)`)
            .attr("id", `avgtextid${this.dynamicCntainer}`)
            .style('font-size',"9px")
            .style('font-weight',"500")
            .style("font-family", "'Montserrat',sans-serif")

            svg.append("g")
            .append("text")
            .attr("x", xScale(0))
            .attr("y", ((avgLineYscale < 0 || avgLineYscale == 0)?  50 : avgLineYscale+15))
            .text( seconds_format )
            .attr("transform", `translate(${5},0)`)
            .attr("class", `avrg-text`)
            .style("font-size", "10px")
            .style("font-weight","600")
            .style("color", "#4E4B66")
            .style("font-family", "'Montserrat',sans-serif")
            .attr("id", `avgtextvalueid${this.dynamicCntainer}`)

    // }
  }
  MobileScreen(){
    return (window.innerWidth > 319 && window.innerWidth <  769)
  }
  toolTipshow(d,i){
    var tooltip = d3.select(`#${this.dynamicid}`)
    const time = getTimeDetails( i?.frequency)?.replace(' ',': ')?.replace('m','')
    d3.select( '#barlinetooltip').remove()
     tooltip = d3.select(`#${this.dynamicid}`)  
    .append("div")
    .attr("id","barlinetooltip")
      .style("position", "absolute")
      .style("height","30px")
      .style("padding","5px")
      .style("background-color","#D9DBE9")
      .style("color",'#4E4B66')
      .style("display",'flex')
      .style("border-radius",'8px')
      .style("justify-content",'center')
      .style("align-items",'center')
      .style("white-space",'nowrap')
      .style("bottom",d?.offsetY+'px')
      .style("font-size","14px")
      .html(`<span>Time-<b class="font-weight-bold">${time }</b></span>`)
      const offsetx = d?.offsetX 
      const barlinetooltipWidth = document.getElementById('barlinetooltip').offsetWidth;
      const  containerwidth = document.getElementById(this.dynamicCntainer).offsetWidth;
      const avgLineXpos = d3.select('#avgtextvalueid'+this.dynamicCntainer).attr("x") ?Number(d3.select('#avgtextvalueid'+this.dynamicCntainer).attr("x")) :0
      var tooltipXpostion = (offsetx +barlinetooltipWidth) < containerwidth ? offsetx :(offsetx - barlinetooltipWidth)
      tooltipXpostion =  Math.max(avgLineXpos,tooltipXpostion)      
      tooltip.style("left",tooltipXpostion  +'px')
      tooltip.select('#barlinetooltip').text(time)
  }
    ngOnDestroy(){
        d3.select(`#${this.dynamicid}`).selectAll('svg').remove();
    }
}
